import { render, staticRenderFns } from "./_locationSlug.vue?vue&type=template&id=7132af36&"
import script from "./_locationSlug.vue?vue&type=script&lang=js&"
export * from "./_locationSlug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports